import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import DeleteDialog from './deleteDialog';

const TaskBulkDeleteButton = props => (
  <Components.Button
    className="vf-task__bulk-delete-button"
    hint={props.strings.page.buttons.delete}
    iconClassName="versa-delete"
    onClick={() => {
      Utils.Dialog.DialogManager.open((
        <DeleteDialog
          dataIds={props.dataIds}
        />
      ));
    }}
  />
);

TaskBulkDeleteButton.displayName = 'Task Bulk Delete Button';

TaskBulkDeleteButton.propTypes = {
  dataIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  strings: PropTypes.shape({
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        delete: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default translate('Task')(TaskBulkDeleteButton);
